import * as React from "react";
const SvgFunnel = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 40, height: 80, viewBox: "0 0 40.0 80.0", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M 0.0 0.0 L 20.0 35.0 L 40.0 0.0 M 20.0 35.0 L 20.0 80.0", fill: "none", stroke: "currentColor", strokeWidth: 1 }));
export default SvgFunnel;
